import { FieldActionOnValuesFunction } from '../types';
import { forEach, keys } from 'lodash';
import { TitleEnumDesc, Title } from '../../api/models/';
import { SelectInputOptions } from '../../components/input/selectInput/types';
import { ContactDetailsModel } from '../../api/models/advanceOverseasFinding/ContactDetailsModel';

export const getTitleOptions = () => {
    const options: SelectInputOptions[] = [{ value: ``, label: `` }];
    forEach(keys(TitleEnumDesc), key => {
        options.push({ label: TitleEnumDesc[key as Title], value: key });
    });
    return options;
};

export const contactDetails: FieldActionOnValuesFunction<ContactDetailsModel> = {
    registeredTaxAgentContactTitle: getTitleOptions,
    primaryTaxAgentContactTitle: getTitleOptions,
};

export default contactDetails;
